  <div class="input-group mb-3">
      <span class="input-group-text" id="inputGroup-sizing-default">ID</span>
      <input id="Id" [(ngModel)]="usuario.id" type="text" class="form-control" aria-label="Id"
        aria-describedby="inputGroup-sizing-default" disabled>
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Nombre y Apellido</span>
    <input id="Nombre" [(ngModel)]="usuario.nombre" type="text" class="form-control" aria-label="Nombre"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Usuario</span>
    <input id="Usuario" [(ngModel)]="usuario.email" type="text" class="form-control" aria-label="Usuario"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Password</span>
    <input id="Password" [(ngModel)]="usuario.password" type="text" class="form-control" aria-label="Password"
      aria-describedby="inputGroup-sizing-default">
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Vehiculo</span>
    <select class="form-select" aria-label="Select Vehiculo" [(ngModel)]="usuario.id_vehiculo">
      <option *ngFor="let m of vehiculos" value={{m.id}}>{{m.marca +" "+ m.modelo+" ("+m.patente + ") "+ m.detalle}}</option>
    </select>
  </div>
  
  <table class="table table-hover table-sm table-responsive mt-3 text-center">
    <thead class="table-dark">
      <tr>
        <th scope="col">Nro</th>
        <th scope="col">Aplicacion</th>
        <th scope="col">Acción</th>
      </tr>
    </thead>
    <tbody class="table-light">
      <tr *ngFor="let m of appsUsuario">
        <th *ngIf="m.estado===true">{{m.id}}</th>
        <th *ngIf="m.estado===true">{{m.appNombre}}</th>
        <td *ngIf="m.estado===true">
          <button type="button" class="btn btn-danger btn-sm" (click)="quitarPermiso(m.id_app)">Quitar</button>
        </td>
        <th *ngIf="m.estado===false" class="table-danger">{{m.id}}</th>
        <th *ngIf="m.estado===false" class="table-danger">{{m.appNombre}}</th>
        <td *ngIf="m.estado===false" class="table-danger">
          <button type="button" class="btn btn-danger btn-sm" (click)="quitarPermiso(m.id_app)">Quitar</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Aplicaciones</span>
    <select class="form-select" aria-label="Select App" [(ngModel)]="idApp">
      <option *ngFor="let m of apps" value={{m.id}}>{{m.descripcion}}</option>
    </select>
    <button class="btn btn-primary" type="button" (click)="agregarPermiso()">Agregar</button>
  </div>

  <div class="form-floating text-center justify-content-md-end">
    <button type="button" class="btn btn-primary" (click)="guardar()" [mat-dialog-close]="usuario">Guardar</button>
  </div>
